import { get, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

const LENDER_HEADER = { "x-role": "lender" };

export const getLenderProjectDetail = (projectId: string) =>
  get(ENDPOINTS.PROJECTS.DETAIL(projectId), null, LENDER_HEADER);

export const getLenderPendingDraw = (projectId: string) =>
  get(ENDPOINTS.LENDER.PENDING_DRAW_APPROVAL(projectId), null, LENDER_HEADER);

export const lenderDrawAction = (
  projectId: string,
  drawId: string,
  data: { action: "approved" | "rejected"; lenderNote: string },
) => post(ENDPOINTS.LENDER.DRAW_ACTION(projectId, drawId), data, LENDER_HEADER);

export const getLenderDrawComments = (projectId: string, drawId: string) =>
  get(ENDPOINTS.LENDER.COMMENTS(projectId, drawId), null, LENDER_HEADER);

export const postLenderDrawComment = (
  projectId: string,
  drawId: string,
  body: string,
) =>
  post(ENDPOINTS.LENDER.COMMENTS(projectId, drawId), { body }, LENDER_HEADER);

export const getLenderDraws = (projectId: string) =>
  get(ENDPOINTS.DRAWS.LIST(projectId), null, LENDER_HEADER);

export const getLenderPreconReview = (
  projectId: string,
  isPreConstruction?: boolean,
) =>
  get(
    ENDPOINTS.PRECON.GC_REVIEW(projectId, isPreConstruction),
    null,
    LENDER_HEADER,
  );
export const getLenderDrawDetail = (projectId: string, drawId: string) =>
  get(ENDPOINTS.DRAWS.DETAIL(projectId, drawId), null, LENDER_HEADER);

export const lenderSovAction = (
  projectId: string,
  data: { lenderAction: "approved" | "rejected"; note: string },
) =>
  post(ENDPOINTS.PROJECTS.LENDER_PRECON_ACTION(projectId), data, LENDER_HEADER);

export const getLenderSovVersions = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_SOV_VERSIONS(projectId), null, LENDER_HEADER);
